<template>
  <div>
    <MonthlyReportTable v-if="getTab == 1" />
    <DetailReportTable v-if="getTab == 2" />
  </div>
</template>

<script>
import ViaticTable from "@/views/monitoring/views/viatic/components/ViaticTable.vue";
import DetailReportTable from "@/views/monitoring/views/reports/components/DetailReportTable.vue";
import MonthlyReportTable from "@/views/monitoring/views/reports/components/MonthlyReportTable.vue";

export default {
  components: {
    ViaticTable,
    DetailReportTable,
    MonthlyReportTable,
  },
  data() {
    return {};
  },
  computed: {
    getTab() {
      return this.$route.meta.tab;
    },
  },
};
</script>

<style>
</style>